import { render, staticRenderFns } from "./autocomplete-patients.vue?vue&type=template&id=3e97b0fd&scoped=true&lang=pug&"
import script from "./autocomplete-patients.vue?vue&type=script&lang=ts&"
export * from "./autocomplete-patients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e97b0fd",
  null
  
)

export default component.exports